import React from "react";
import { CommandBarButton, IconButton } from "@fluentui/react";
import DetailsTable from "../../../Table/DetailsTable";
import FeatureSummary from "../../../Util/FeatureSummary";

const JournalTable = ({
    journalTable,
    setSelectedPromptId,
    setSelectedPromptTitle,
    cloneOnClick,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
    previewOnClick,
}) => {
    const columns = [
        {
            key: "menu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    cloneOnClick={cloneOnClick}
                    deleteOnClick={deleteOnClick}
                    previewOnClick={previewOnClick}
                    id={item.journalPromptId}
                    prompt={item.prompt}
                />
            ),
        },
        {
            key: "column1",
            name: "ID",
            fieldName: "journalPromptId",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column2",
            name: "Prompt",
            fieldName: "prompt",
            minWidth: 450,
            maxWidth: 600,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column3",
            name: "Category",
            fieldName: "category",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column4",
            name: "Created On",
            fieldName: "createdOn",
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column5",
            name: "International",
            fieldName: "international",
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column6",
            name: "Global",
            fieldName: "isGlobal",
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column7",
            name: "Checklist Only",
            fieldName: "checklistOnly",
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = journalTable ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedPromptId(selectedItem && selectedItem.journalPromptId);
        setSelectedPromptTitle?.(selectedItem?.prompt || "");
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'category'}
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Add Journal Prompt"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Journals"
                summary="This table displays all journal prompts, including the prompt text, category, and creation date. You can add, edit, or delete prompts. The Journals feature allows admins to manage reflective prompts that encourage users to engage in mindfulness and personal growth."
                imageUrlPath="journals"
            />
        </>
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    cloneOnClick,
    deleteOnClick,
    prompt,
    id,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "Edit",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, prompt),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => {}}
            {...rest}
        />
    );
};

export default JournalTable;
